import type { TagDefinition, TagRegistry } from './tagRegistry'

// Local copy of createStableTagId — a runtime import from tagRegistry would create an
// import cycle (tagRegistry → canonicalRatingTags → this file → tagRegistry).
function stableId(seed: string): string {
  let hash = 2166136261
  for (let i = 0; i < seed.length; i++) {
    hash ^= seed.charCodeAt(i)
    hash = Math.imul(hash, 16777619) >>> 0
  }
  return `tag_${hash.toString(36)}`
}

/** Author discussion marker, persisted with the regular section tags. */
export const DISCUSSED_TAG_ID = stableId('manifesto.section.discussed')

export const DISCUSSED_TAG_NAME = 'דיברנו עליו'

export const DISCUSSED_TAG_DEFAULT: TagDefinition = {
  name: DISCUSSED_TAG_NAME,
  parentIds: [],
  description: 'התקיימה שיחה על המקטע; אינו מעיד שהעיבוד הושלם',
  color: '#64B5F6',
  order: 27,
}

export function ensureProtectedDiscussedTag(registry: TagRegistry): TagRegistry {
  const existing = registry.tags[DISCUSSED_TAG_ID]
  const next: TagDefinition = {
    ...DISCUSSED_TAG_DEFAULT,
    ...(existing?.hidden ? { hidden: true } : {}),
  }
  if (existing && JSON.stringify(next) === JSON.stringify(existing)) {
    return registry
  }
  return { ...registry, tags: { ...registry.tags, [DISCUSSED_TAG_ID]: next } }
}
